<div class="flex-container gap-6" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.w_certificat_bio_echeance' | trans" [accent]="accentText()" [widget]="widget()" [draggable]="true">
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>
  </vl-widget-title>

  @if (loading()) {
    <div class="flex-col gap-12 widget-content">
      <ngx-skeleton-loader count="4" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
    </div>
  } @else if (alertItems().length) {
    <div class="flex-col w100 widget-content fade-in" style="overflow: hidden; gap: 6px">
      <div class="flex-col gap-4 grow" style="overflow: auto; min-height: 0">
        @for (item of alertItems(); track item.id) {
          <div class="row-cert" (click)="goToTiers(item.tiersId)">
            <mat-icon class="bio-icon shrink-0" [class]="statusClass(item.joursRestants)">eco</mat-icon>
            <span class="grow body-2 ellipsis" [matTooltip]="item.tiersDenomination">{{ item.tiersDenomination }}</span>
            <span class="status-pill shrink-0" [class]="statusClass(item.joursRestants)">
              {{ statusLabel(item) }}
            </span>
            <mat-icon class="go-icon shrink-0 on-background-alt">open_in_new</mat-icon>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="flex-col align-center justify-center grow">
      <mat-icon class="on-valid" style="font-size: 32px; width: 32px; height: 32px">verified</mat-icon>
      <span class="caption on-background-alt mt-8">{{ 'dashboard_ui.w_certificat_bio_echeance_desc' | trans }}</span>
      <span class="caption on-valid">Tous à jour</span>
    </div>
  }
</div>
